import axios from "@/apis/axios-client";

const ListConnectionParameter = async () => {

  return await axios.client
    .get(
      "/api/connectionparameter",
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    )
    .then((response) => {
      return response;
    })
    .catch((error) => {
      console.log("Login error:", error);
      return error;
    });
};

const CreateConnectionParameter = async (ConnectionParameter) => {

  return await axios.client
    .post(
      "/api/connectionparameter",
      ConnectionParameter,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    )
    .then((response) => {
      return response;
    })
    .catch((error) => {
      console.log("CreateConnectionParameter:", error);
      return error;
    });
};

const UpdateConnectionParameter = async (ConnectionParameter) => {

  return await axios.client
    .put(
      "/api/connectionparameter",
      ConnectionParameter,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    )
    .then((response) => {
      return response;
    })
    .catch((error) => {
      console.log("UpdateConnectionParameter:", error);
      return error;
    });
};

const DeleteConnectionParameter = async (id) => {

  return await axios.client
    .delete(
      "/api/connectionparameter/" + id,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    )
    .then((response) => {
      return response;
    })
    .catch((error) => {
      console.log("DeleteConnectionParameter:", error);
      return error;
    });
};

const UseConnectionCheck = async (ConnectionParameter) => {

  return await axios.client
    .post(
      "/api/connectionparameter/checkconnection",
      ConnectionParameter,
      {
        headers: {
          "Content-Type": "application/json",
        },
      })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      console.log("Connection Check:", error);
      return error;
    });
};


const ConnectionParameterClockitApi = {
  ListConnectionParameter: ListConnectionParameter,
  CreateConnectionParameter: CreateConnectionParameter,
  UpdateConnectionParameter: UpdateConnectionParameter,
  DeleteConnectionParameter: DeleteConnectionParameter,
  UseConnectionCheck: UseConnectionCheck,
};

export default ConnectionParameterClockitApi;